import { usePermission } from 'hooks/use-permission/use-permission';
import { hasFeatureFlags } from 'core/flow-control';

export const useMyZonePermissions = () => {
    const hasEnableCustomPoiPermission = usePermission('enable_custom_poi');

    const hasEnableBillboardsPermission = usePermission('show_billboards');

    const hasEnablePurchasedPOIsPermission = usePermission('enable_my_zone_purchased_pois');

    const hasEnableChainsSearchInTagsPermission = usePermission('enable_chains_search_in_tags');

    const hasEnableEmbeddedIframeMyZonePermission = usePermission(
        'enable_embedded_iframe_my_zone_ff',
    );

    const hasHideCompanyTags = hasFeatureFlags(['hide_company_tags']);
    const hasEnableCompanyLogoPermission = hasFeatureFlags(['enable_company_logo_name_in_my_zone']);

    return {
        hasEnableCustomPoiPermission,
        hasEnableBillboardsPermission,
        hasEnablePurchasedPOIsPermission,
        hasEnableChainsSearchInTagsPermission,
        hasEnableCompanyLogoPermission,
        hasEnableEmbeddedIframeMyZonePermission,
        hasHideCompanyTags,
    };
};
